import ShipmentPage from "./Shipment"
import ShipmentStatisticPage from "./Shipments"
import ShipmentStatisticFboPage from "./ShipmentsFbo"

const StatisticPages = {
    ShipmentStatistic: ShipmentStatisticPage,
    ShipmentStatisticFbo: ShipmentStatisticFboPage,
    Shipment: ShipmentPage,
}

export default StatisticPages